import { useNavigate } from 'react-router-dom';
import { BOOKING_BASE } from 'routes';

export const confirmedRedirect = (id, confirmed, navigate) => {
	if (confirmed) {
		navigate(BOOKING_BASE + id + '/tech');
	}
};
